import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {inchesToMm} from "../../../../helpers/sqftHelper";

const SqftSummaryWall = (props) => {
  const {measureUnit, intl} = props;
  const {walls} = props;
  let messageTotal;

  return (
    walls.map((wall, index) => {
      switch(measureUnit) {
        case "Metric":
          messageTotal = "Total : "+ inchesToMm(wall.length) + " mm";
          break;
        case "Imperial":
        default:
          messageTotal = intl.formatMessage({id: "sqft.navigation.summary.totalInches"}) + " " + wall.length +"\"";
      }

      return (
        <div className="summary-list__item summary summary--black" key={index}>
          <div className="summary-title">
            { wall.name.replace(/"/g, "&quot;") }
          </div>
          <div className="summary-info">
            <div className="summary-info__left">
              <FormattedMessage id="sqft.navigation.summary.segments"/>: {wall.segments}
            </div>
            <div className="summary-info__right">{messageTotal}</div>
          </div>
        </div>
      )
    })
  )
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton,
  measureUnit: store.sqftState.measureUnit
});

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftSummaryWall)
);
